import { RiArrowRightLine } from "@remixicon/react";

interface ExchangeLink {
  pair: string;
  url: string;
}

interface ExchangeCardProps {
  exchange: {
    id: string;
    name: string;
    logo: string;
    description: string;
    links: ExchangeLink[];
    type: "dex" | "cex";
    icon: string;
  };
}

export function ExchangeCard({ exchange }: ExchangeCardProps) {
  // Get the USDT pair link or the first available link
  const getExchangeLink = () => {
    const usdtPair = exchange.links.find(link => link.pair.includes('USDT') || link.pair.includes('USDT'));
    return usdtPair ? usdtPair.url : exchange.links[0].url;
  };

  return (
    <a
      href={getExchangeLink()}
      target="_blank"
      rel="noopener noreferrer"
      className="group block"
    >
      <div className="relative overflow-hidden rounded-xl bg-sidebar border border-border hover:border-[#FF8A3C]/50 dark:hover:border-[#FF8A3C]/50 transition-all duration-300 h-full">
        {/* Card top accent */}
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-[#FF8A3C] to-[#FF8A3C]/70 transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>

        {/* Card content */}
        <div className="p-6 flex flex-col h-full">
          {/* Exchange icon/initial */}
          <div className="mb-5 flex items-center">
            <div className="w-12 h-12 rounded-lg bg-white flex items-center justify-center mr-3 overflow-hidden">
              <div className="relative w-8 h-8">
                <img
                  src={exchange.logo}
                  alt={exchange.name}
                  width={32}
                  height={32}
                  className="object-contain"
                />
              </div>
            </div>
            <div className="flex-1">
              <div className="flex justify-between items-center">
                <h3 className="text-lg font-semibold group-hover:text-[#FF8A3C] transition-colors">
                  {exchange.name}
                </h3>
                <RiArrowRightLine className="size-5 text-muted-foreground group-hover:text-[#FF8A3C] transform translate-x-0 group-hover:translate-x-1 transition-all duration-300" />
              </div>
            </div>
          </div>

          {/* Description */}
          <p className="text-sm text-muted-foreground mb-6 flex-grow">
            {exchange.description}
          </p>

          {/* Exchange type */}
          <div className="mt-auto">
            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-muted text-muted-foreground">
              {exchange.type === "dex" ? "Decentralized Exchange" : "Centralized Exchange"}
            </span>
          </div>
        </div>
      </div>
    </a>
  );
}
